import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clock-location"
export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    this.readyToSubmit = false
  }

  submit(event) {
    if (this.readyToSubmit) {
      this.readyToSubmit = false
      return
    }

    event.preventDefault()

    if (!navigator.geolocation) {
      this.notifyError("Trình duyệt không hỗ trợ định vị. Vui lòng dùng thiết bị khác.")
      return
    }

    this.setPendingState(true)

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitudeField = this.latitudeField()
        const longitudeField = this.longitudeField()

        if (!latitudeField || !longitudeField) {
          this.setPendingState(false)
          this.notifyError("Không thể lưu vị trí. Vui lòng tải lại trang và thử lại.")
          return
        }

        latitudeField.value = position.coords.latitude
        longitudeField.value = position.coords.longitude
        this.readyToSubmit = true
        this.setPendingState(false)
        this.element.requestSubmit()
      },
      (error) => {
        this.setPendingState(false)
        this.notifyError(this.errorMessage(error))
      },
      {
        enableHighAccuracy: true,
        timeout: this.timeoutValue || 8000,
        maximumAge: 0
      }
    )
  }

  setPendingState(pending) {
    const submitButton = this.element.querySelector("button[type='submit']")
    if (!submitButton) {
      return
    }

    submitButton.disabled = pending
    submitButton.setAttribute("aria-busy", pending.toString())
  }

  errorMessage(error) {
    switch (error.code) {
    case 1:
      return "Vui lòng bật quyền định vị để chấm công."
    case 2:
      return "Không lấy được vị trí hiện tại. Vui lòng thử lại."
    case 3:
      return "Không thể lấy vị trí kịp thời. Vui lòng thử lại."
    default:
      return "Không thể lấy vị trí. Vui lòng thử lại."
    }
  }

  notifyError(message) {
    alert(message)
  }

  latitudeField() {
    return this.element.querySelector("input[name='clock[latitude]']")
  }

  longitudeField() {
    return this.element.querySelector("input[name='clock[longitude]']")
  }
}
